import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import UserListModal from 'common/audience/controllers/UserListModal'
import * as builderStateActions from 'common/builder/actions/builderStateActions'
import builderSelectors from 'common/builder/selectors/builder'

class SegmentViewerModalController extends Component {
  handleClose = () => {
    const { builderId } = this.props
    this.props.builderStateActions.selectSegment(builderId, null)
  }

  getSegmentFilter = () => {
    const { selectedSegment } = this.props

    return {
      operator: 'OR',
      groups: [
        {
          operator: 'OR',
          items: [{ item: selectedSegment }],
        },
      ],
    }
  }

  render() {
    const { selectedSegment } = this.props

    return (
      <UserListModal
        onClose={this.handleClose}
        isOpen={Boolean(selectedSegment)}
        query={{
          filter: this.getSegmentFilter(),
          active: 0,
          q: '',
        }}
        enableTagging
      />
    )
  }
}

export default connect(
  (state, props) => {
    const builder = builderSelectors.builderState.getById(state, props.builderId)

    return {
      selectedSegment: builder.selectedSegment,
    }
  },
  (dispatch) => ({
    builderStateActions: bindActionCreators(builderStateActions, dispatch),
  }),
)(SegmentViewerModalController)
